import { Alert } from '@medely/ui-kit';
import React, { useEffect, useState } from 'react';
import { StringParam, useQueryParams } from 'use-query-params';
import CenteredLoader from '../CenteredLoader';

const TIMEOUT_IN_MS = 7000;
const CHECK_INTERVAL_IN_MS = 500;

export const HelpArticle = () => {
  const [hasReachedTimeout, setHasReachedTimeout] = useState(false);
  const [validIntercomSession, setValidIntercomSession] = useState(false);
  const [{ url }] = useQueryParams({ url: StringParam });
  const canShowArticle = Boolean(url && validIntercomSession);

  useEffect(() => {
    const interval = setInterval(() => {
      const getIntercomCookieSession = document.cookie.match(
        new RegExp('intercom-session-([^;]+)'),
      );
      const isValid = Boolean(
        getIntercomCookieSession && getIntercomCookieSession[0].split('=')[1] !== '',
      );
      setValidIntercomSession(isValid);
    }, CHECK_INTERVAL_IN_MS);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      setHasReachedTimeout(true);
    }, TIMEOUT_IN_MS);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    if (canShowArticle && url) {
      window.location.replace(url);
    }
  }, [canShowArticle, url]);

  if (hasReachedTimeout && !canShowArticle) {
    return (
      <Alert
        severity="error"
        title="Unable to open this link"
        description="Please try again."
        hideCloseIcon
      />
    );
  }

  return <CenteredLoader />;
};
